export default __webpack_public_path__ + "static/media/englishFlag.453d77e6.png";